// Zahlen-, Datums- und Mengenformate des Originals (Auftrags-Schnellerfassung).
// Bewusst identisch übernommen, damit Beträge, Stückzahlen und Kalenderwochen
// in der neuen Oberfläche exakt gleich aussehen.

/** Betrag mit zwei Nachkommastellen, deutsches Format (1.234,50). */
export function fmt(v) {
    return Number(v || 0).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}

/** Ganze Zahl, deutsches Format (1.800). */
export function fmt0(v) {
    return Number(v || 0).toLocaleString('de-DE', {maximumFractionDigits: 0});
}

/** Menge aus einem Feldwert lesen — akzeptiert Komma und Punkt. */
export function qtyNum(q) {
    return parseFloat(String(q).replace(',', '.')) || 0;
}

/** Zeitstempel (Millisekunden) als TT.MM.JJJJ. */
export function fmtDate(ts) {
    const d = new Date(+ts);
    return String(d.getDate()).padStart(2, '0') + '.' + String(d.getMonth() + 1).padStart(2, '0') + '.' + d.getFullYear();
}

/** Kalenderwoche nach ISO 8601 zu einem Zeitstempel. */
export function isoWeek(ts) {
    const d = new Date(+ts);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 3 - ((d.getDay() + 6) % 7));
    const w1 = new Date(d.getFullYear(), 0, 4);
    return 1 + Math.round(((d - w1) / 86400000 - 3 + ((w1.getDay() + 6) % 7)) / 7);
}

/** Geplanter Wareneingang als TT.MM.JJ (Einkaufsinfo an der Verfügbarkeit). */
export function fmtWeDate(value) {
    if (!value) {
        return '?';
    }
    return new Date(value).toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: '2-digit'});
}
